module.exports = __webpack_public_path__ + "static/media/Loader Blue.d6031d61.svg";